export default __webpack_public_path__ + "psn-app.29a14343845517e3fb2a0745e587515b.css";